_collow.components.Toaster = class Toaster extends (_collow.components.Base) {
    root;
    template;
    message;
    actionLabel;
    action;
    href;
    type;
    size;
    showIcon;
    elements;
    closeToaster;

    icons = {
        success: 'fa-check',
        error: 'fa-xmark',
        info: 'fa-circle-info'
    }
    innerElementsMap = {
        iconContainer: '.toaster__icon',
        icon: '.toaster__icon > i',
        message: '.toaster__message',
        actionContainer: '.toaster__cta',
        action: '.toaster__cta > a',
        close: '.toaster__close'
    }

    constructor(params) {
        super();

        Object.assign(this, params);
        this.template = params.template.cloneNode(true);
        this._mapElements();

        return this._createElement();
    }

    /** Maps the inner elements of the toaster */
    _mapElements = () => {
        this.elements = Object.fromEntries(
            Object.entries(this.innerElementsMap).map(
                ([key, value]) => [key, this.template.querySelector(value)]
            )
        );
    }

    /** Adds the necessary classes and content to the template */
    _setElementContent = () => {
        this.template.classList.add(this.type, this.size);
        this.elements.icon.classList.add(this.icons[this.type]);
        this.elements.message.innerHTML = this.message;
        if (this.showIcon) this.elements.iconContainer.removeAttribute('hidden');
    }

    /** Handles the action button configuration */
    _configureAction = () => {
        if (!this.actionLabel) return this.elements.close.removeAttribute('hidden');

        this.elements.action.innerHTML = this.actionLabel;

        if (this.action) {
            this.elements.action.addEventListener('click', this.action);
        } else if (this.href) {
            this.elements.action.href = this.href;
            this.elements.action.target = this.target;
        }

        this.elements.actionContainer.removeAttribute('hidden');
    }

    _assignCloseEvent = () => {
        this.elements.close.addEventListener('click', () => this.closeToaster(this.template));
    }

    _createElement = () => {
        this._setElementContent();
        this._configureAction();
        this._assignCloseEvent();
        return this.template;
    }
}
